import styled from "styled-components/macro";
import React, { useEffect, useState } from "react";
import { ReactComponent as DitoIconActive } from "../assets/dito_icon_active.svg";
import { ReactComponent as DitoIcon } from "../assets/dito_icon.svg";
import {
  MdAccountBalance,
  MdArrowBackIos,
  MdAutoAwesome,
  MdCalendarToday,
  MdCampaign,
  MdChat,
  MdChatBubbleOutline,
  MdClose,
  MdFavoriteBorder,
  MdGroup,
  MdGroups,
  MdMail,
  MdMailOutline,
  MdOutlineCampaign,
  MdPersonOutline,
  MdSearch,
  MdTaskAlt,
} from "react-icons/md";

import "../styles/App.css";
import { useLocation, useNavigate } from "react-router";
import { useParams } from "react-router-dom";
import { isEmpty } from "../functions/isEmpty";
import { useLanguage } from "../contexts/LanguageContext";

export default function Bottombar({ isMobile, user }) {
  let navigate = useNavigate();
  const location = useLocation();
  const { language, switchLanguage } = useLanguage();

  if (
    location.pathname != "/" &&
    location.pathname != "/inbox" &&
    location.pathname != "/finance" &&
    location.pathname != "/marketing" &&
    location.pathname != "/calendar"
  ) {
    return <></>;
  }

  return (
    <div className="app_bottombar">
      <div
        className={
          location.pathname == "/inbox"
            ? "app_bottombar_navlink active"
            : "app_bottombar_navlink"
        }
        onClick={() => navigate("/inbox")}>
        {location.pathname == "/inbox" ? <MailIconActive /> : <MailIcon />}
        Posteingang
      </div>
      <div
        className={
          location.pathname == "/finance"
            ? "app_bottombar_navlink active"
            : "app_bottombar_navlink"
        }
        onClick={() => navigate("/finance")}>
        {location.pathname == "/finance" ? <BankIconActive /> : <BankIcon />}
        Finanzen
      </div>
      <div
        className={
          location.pathname == "/marketing"
            ? "app_bottombar_navlink active"
            : "app_bottombar_navlink"
        }
        onClick={() => navigate("/marketing")}>
        {location.pathname == "/marketing" ? (
          <CampaingIconActive />
        ) : (
          <CampaignIcon />
        )}
        Social Media
      </div>
      <div
        className={
          location.pathname == "/calendar"
            ? "app_bottombar_navlink active"
            : "app_bottombar_navlink"
        }
        onClick={() => navigate("/calendar")}>
        {location.pathname == "/calendar" ? (
          <CalendarIconActive />
        ) : (
          <CalendarIcon />
        )}
        Termine
      </div>
      <div
        className={
          location.pathname == "/"
            ? "app_bottombar_navlink active"
            : "app_bottombar_navlink"
        }
        onClick={() => navigate("/")}>
        {location.pathname == "/" ? (
          <DitoIconActiveStyled />
        ) : (
          <DitoIconStyled />
        )}
        Ditos
      </div>
    </div>
  );
}

const DitoIconStyled = styled(DitoIcon)`
  width: 25px;
  height: 25px;
  color: #717171;
`;

const DitoIconActiveStyled = styled(DitoIconActive)`
  width: 26px;
  height: 26px;
  color: #ff29a7;
  margin-bottom: 1px;
`;

const PersonIcon = styled(MdPersonOutline)`
  font-size: 30px;
  color: #717171;
`;

const PersonIconActive = styled(MdPersonOutline)`
  font-size: 30px;
  color: #2d81e0;
`;

const GroupIcon = styled(MdGroups)`
  font-size: 30px;
  color: #717171;
`;

const GroupIconActive = styled(MdGroups)`
  font-size: 30px;
  color: #2d81e0;
`;

const SearchIcon = styled(MdSearch)`
  font-size: 32px;
  color: #717171;
  margin-bottom: -2px;
`;

const SearchIconActive = styled(MdSearch)`
  font-size: 32px;
  color: #ff29a7;
  margin-bottom: -2px;
`;

const ChatsIcon = styled(MdChatBubbleOutline)`
  font-size: 26px;
  color: #717171;
`;

const ChatsIconActive = styled(MdChatBubbleOutline)`
  font-size: 26px;
  color: #2d81e0;
`;

const TasksIcon = styled(MdTaskAlt)`
  font-size: 26px;
  color: #717171;
`;

const TaskIconActive = styled(MdTaskAlt)`
  font-size: 26px;
  color: #2d81e0;
`;

const AutoIcon = styled(MdAutoAwesome)`
  font-size: 26px;
  color: #717171;
`;

const AutoIconActive = styled(MdAutoAwesome)`
  font-size: 26px;
  color: #2d81e0;
`;

const MailIcon = styled(MdMailOutline)`
  font-size: 31px;
  color: #717171;
  margin-bottom: -2px;
`;

const MailIconActive = styled(MdMail)`
  font-size: 31px;
  color: #ff29a7;
  margin-bottom: -2px;
`;

const BankIcon = styled(MdAccountBalance)`
  font-size: 27px;
  color: #717171;
  margin-bottom: -1px;
`;

const BankIconActive = styled(MdAccountBalance)`
  font-size: 27px;
  color: #ff29a7;
  margin-bottom: -1px;
`;

const CampaignIcon = styled(MdCampaign)`
  font-size: 32px;
  color: #717171;
  margin-bottom: -1px;
`;

const CampaingIconActive = styled(MdCampaign)`
  font-size: 32px;
  color: #ff29a7;
  margin-bottom: -1px;
`;

const CalendarIcon = styled(MdCalendarToday)`
  font-size: 25px;
  color: #717171;
  margin-bottom: 2px;
`;

const CalendarIconActive = styled(MdCalendarToday)`
  font-size: 25px;
  color: #ff29a7;
  margin-bottom: 2px;
`;
